import { render, staticRenderFns } from "./InSendingData.vue?vue&type=template&id=de452e38&"
import script from "./InSendingData.vue?vue&type=script&lang=js&"
export * from "./InSendingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports